import axios, { AxiosResponse } from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';

import {
  fetchPaymentMethodsFailure,
  fetchPaymentMethodsRequest,
  fetchPaymentMethodsSuccess,
  updatePaymentMethodFailure,
  updatePaymentMethodRequest,
  updatePaymentMethodSuccess,
} from './actions';
import { FETCH_PAYMENT_METHODS_REQUEST, UPDATE_PAYMENT_METHOD_REQUEST } from './actionTypes';

const getPaymentMethods = () => axios.get<IPaymentMethod>('/api/v1/payments');

const updatePaymentMethod = async (id: number) => {
  const response = await axios.post<any>(`/api/v1/payments/${id}`);
  return response.data;
};

function* fetchPaymentMethodsSaga() {
  try {
    const response: AxiosResponse<IPaymentMethod> = yield call(getPaymentMethods);

    yield put(
      fetchPaymentMethodsSuccess({
        paymentMethods: response.data,
      }),
    );
  } catch (e: unknown) {
    yield put(
      fetchPaymentMethodsFailure({
        error: e instanceof Error ? e.message : 'Unknown error',
      }),
    );
  }
}

function* updatePaymentMethodSaga(action: ReturnType<typeof updatePaymentMethodRequest>) {
  try {
    const response: AxiosResponse<IPaymentMethod> = yield call(() =>
      updatePaymentMethod(action.payload.id),
    );

    yield put(
      updatePaymentMethodSuccess({
        address: response.data,
      }),
    );

    yield put(fetchPaymentMethodsRequest());
  } catch (e: unknown) {
    yield put(
      updatePaymentMethodFailure({
        error: e instanceof Error ? e.message : 'Unknown error',
      }),
    );
  }
}

export function* paymentMethodsSaga() {
  yield takeLatest(FETCH_PAYMENT_METHODS_REQUEST, fetchPaymentMethodsSaga);
  yield takeLatest(UPDATE_PAYMENT_METHOD_REQUEST, updatePaymentMethodSaga);
}
